<template>
  <div class="timeWidget mr-3 px-3" v-if="isShow" title="Server time">
    <v-icon class="icon">mdi-weather-cloudy-clock</v-icon>
    <span class="ml-2 time" :class="{ hidden: loading }">
      <span>{{ `${hours}:${minutes}` }} ({{ timezoneInfo }})</span>
    </span>
  </div>
</template>

<script>
import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
  watch
} from '@vue/composition-api';
import { getDateWithTimeZone } from '@/utils/getDateWithTimeZone';
import useAuth from '@/api/auth';

export default {
  name: 'TimeWidget',
  setup() {
    const { getTimezoneShift, profile } = new useAuth();
    const isShow = ref(false);

    let timer = null;
    const date = ref(getDateWithTimeZone(0));
    const loading = ref(true);
    const timezoneInfo = ref('');

    const setDate = timezone => {
      date.value = getDateWithTimeZone(timezone);
    };

    watch(
      () => profile,
      () => {
        isShow.value = profile.value.objectProperties.find(
          item => item.key === 'programShowCoreTime'
        )?.value;
      },
      {
        deep: true
      }
    );

    onMounted(async () => {
      let timezone = 0;

      try {
        const { data } = await getTimezoneShift();
        timezone = data.getTimezoneShift;
        timezoneInfo.value = data.getTimezone;
      } finally {
        loading.value = false;
      }

      setDate(timezone);

      timer = setInterval(() => {
        setDate(timezone);
      }, 1000);
    });
    onBeforeUnmount(() => {
      timer && clearInterval(timer);
    });

    return {
      date,
      loading,
      isShow,
      timezoneInfo,
      hours: computed(() =>
        date.value.getUTCHours() < 10
          ? `0${date.value.getUTCHours()}`
          : date.value.getUTCHours()
      ),
      minutes: computed(() =>
        date.value.getUTCMinutes() < 10
          ? `0${date.value.getUTCMinutes()}`
          : date.value.getUTCMinutes()
      )
    };
  }
};
</script>

<style lang="scss">
.timeWidget {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 40px;
  border-radius: 1000px;
}
.icon {
  color: inherit !important;
}
.time {
  line-height: initial !important;
  font-size: 16px !important;
  font-weight: 600;
  flex-shrink: 0;
}

.hidden {
  visibility: hidden;
}
</style>
